const hasLeadingZeros = (number) => {
  const numberString = String(number);
  return numberString.charAt(0) === '0';
};

export default hasLeadingZeros;
